module.exports = __webpack_public_path__ + "img/balance_bg.5400a69d.png";